// Local project context is available in the Mac app.
export default function NewChatProjectBar() { return null; }
